import styled from "@emotion/styled";

// Temporary file until we convert Location selection to new UI

export const StyledToggleViewContainer = styled.div`
  z-index: 2;
  position: absolute;
  left: 8px;
  right: 8px;
  margin-top: 16px;
`